// extracted by mini-css-extract-plugin
module.exports = {"icon":"PhoneLinkBlock_icon__2JzDw"};